import { ProjectFormEnum } from '../enums/ProjectFormEnum'
import { useStoreProjectFormMutation } from '../api/project/useStoreProjectFormMutation'
import { useGetProjectTechnicalForm } from '../api/project/useGetProjectTechnicalForm'
import { merge } from 'lodash'
import { useSubmitForPreviewProjectFormMutation } from '../api/project/useSubmitForPreviewProjectFormMutation'
import { useDeletePreviewProjectTechnicalFormMutation } from '../api/project/useDeletePreviewProjectTechnicalFormMutation'
import { useGetTechnicalFormsList } from '../api/project/useGetTechnicalFormsList'
import { projectFormEnumToProjectFormCategory, TechnicalFormStatusEnum } from 'shared'
import { useNavigate } from 'react-router-dom'
import { RoutesEnum } from '../enums/RoutesEnum'
import { useToast } from '@chakra-ui/react'

export const useTechnicalReportForm = (
  projectId: string,
  formEnum: ProjectFormEnum,
  initialValues: object,
) => {
  const navigate = useNavigate()
  const toast = useToast()

  const { mutate: storeTechnicalForm, isLoading: storeTechnicalFormIsLoading } =
    useStoreProjectFormMutation(formEnum)
  const { mutate: submitForPreviewProjectForm, isLoading: submitForPreviewIsLoading } =
    useSubmitForPreviewProjectFormMutation()
  const { mutate: deletePreviewProjectTechnicalForm, isLoading: deletePreviewIsLoading } =
    useDeletePreviewProjectTechnicalFormMutation()

  const {
    data: technicalForm,
    isLoading: technicalFormIsLoading,
    isRefetching: technicalFormIsRefetching,
  } = useGetProjectTechnicalForm(formEnum, projectId!)

  const { data: listData } = useGetTechnicalFormsList(
    projectId,
    projectFormEnumToProjectFormCategory(formEnum),
  )
  const accompanyingReportNotFinished = !!listData?.data?.list?.a?.find(
    (form) => form.status === TechnicalFormStatusEnum.EDIT,
  )

  if (accompanyingReportNotFinished) {
    toast({
      title: 'Souhrnnou zprávu nelze vyplnit před dokončením Průvodního listu',
      status: 'warning',
      duration: 9000,
      isClosable: true,
      position: 'top-right',
    })

    navigate(`/${RoutesEnum.PROJECTS}/${projectId}/${RoutesEnum.ACCOMPANYING_REPORT}`)
  }

  return {
    storeTechnicalForm,
    storeTechnicalFormIsLoading,
    technicalForm,
    technicalFormIsLoading: technicalFormIsLoading,
    technicalFormIsRefetching,
    initialValues: merge(structuredClone(initialValues), technicalForm?.data?.data || {}) as any,
    submitForPreviewIsLoading,
    submitForPreviewProjectForm: () =>
      submitForPreviewProjectForm({ id: projectId, form: formEnum }),
    deletePreviewIsLoading,
    deletePreviewProjectTechnicalForm: () =>
      deletePreviewProjectTechnicalForm({ id: projectId, form: formEnum }),
  }
}
